import { render, staticRenderFns } from "./ProfileEditTabCertificates.vue?vue&type=template&id=06ec4826&scoped=true&"
import script from "./ProfileEditTabCertificates.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabCertificates.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabCertificates.vue?vue&type=style&index=0&id=06ec4826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec4826",
  null
  
)

export default component.exports